import { createApp } from 'vue';
import { createFavoritesHandlerComponent } from './favoritesHandler';
import styles from '../../css/favorites-handler.css?inline';

/**
 * Mount favorites handler using inline template from the DOM
 * This version uses Shadow DOM to isolate styles
 */
const mountFavorites = (selector = '#favorites-handler', props = {}) => {
    console.log(`[FavoritesHandler] Attempting to mount on "${selector}"...`);

    const hostElement = document.querySelector(selector);
    if (!hostElement) {
        console.warn(`[FavoritesHandler] Element "${selector}" not found.`);
        return null;
    }

    // Capture template BEFORE creating the app or shadow root
    // Clone logic: we need the innerHTML to serve as the template
    const template = hostElement.innerHTML;

    if (!template.trim()) {
        console.error("[FavoritesHandler] Found element but it has no content/template.");
        return null;
    }

    console.log("[FavoritesHandler] Template captured. Length:", template.length);

    // Create Shadow DOM
    const shadowRoot = hostElement.attachShadow({ mode: 'open' });

    // Inject Styles
    const styleTag = document.createElement('style');
    styleTag.textContent = styles;
    shadowRoot.appendChild(styleTag);

    // Create App Container inside Shadow DOM
    const appContainer = document.createElement('div');
    appContainer.id = 'favorites-app-container';
    shadowRoot.appendChild(appContainer);

    // Get the base component definition
    const baseComponent = createFavoritesHandlerComponent(props);

    // Add the template property - Vue 3 will compile it
    const component = {
        ...baseComponent,
        template: template
    };

    const app = createApp(component);

    // Clear element content before mounting (although shadow DOM hides it, good to clean up)
    hostElement.innerHTML = '';

    console.log("[FavoritesHandler] Mounting Vue app into Shadow DOM...");
    app.mount(appContainer);
    console.log("[FavoritesHandler] Mounted successfully.");

    return app;
};

// Robust auto-init
const init = () => {
    if (document.querySelector('#favorites-handler')) {
        mountFavorites('#favorites-handler', window.favoritesConfig || {});
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

// Expose globally
window.initFavoritesHandler = mountFavorites;
